<template>
  <div id="miniform" :class="formStyle + ' ' + hideStyle">
    <div class="light-layer" :class="'level-'+fillingLevel" v-if="!checkDataIsEmpty && !isMobileView">
      <div class="row">
        <div class="col numbered col-md-2" >
          <ServiceType
            :fieldData="formDatas['service_type']"
            :fieldValue.sync="serviceType"
            :fillingLevel.sync="fillingLevel"
          />
        </div>
        <div class="col numbered col-md-2" >
          <SourceLanguage
            :fieldData="formDatas['source_language']"
            :fieldValue.sync="sourceLanguage"
            :fillingLevel.sync="fillingLevel"
            :popup.sync="languagePopup"
          />
        </div>
        <div class="col numbered col-md-2" >
          <TargetLanguage
            :fieldData="formDatas['target_language']"
            :fieldValue.sync="targetLanguage"
            :fillingLevel.sync="fillingLevel"
            :popup.sync="languagesPopup"
          />
        </div>
        <div class="col numbered col-md-2" >
          <Mail
            :fieldValue.sync="mail"
            :fillingLevel.sync="fillingLevel"
          />
        </div>
        <div class="col numbered col-md-2 no-border" >
          <Phone
            :fieldValue.sync="phone"
            :fillingLevel.sync="fillingLevel"
          />
        </div>
        <div class="col col-md-2 send" >
          <div class="form-item">
            <button id="miniform-csaligomb" class="send" @click="track();saveData()">
              Fájlfeltöltés és árak
            </button>
          </div>

          <div v-if="messageShown" class="warning-message text-center">
            Kérjük töltse ki az összes mezőt (1-5) a továbblépéshez
          </div>
        </div>
      </div>
    </div>
    <div class="text-right mobile-view" v-if="!checkDataIsEmpty && isMobileView">
      <button type="button" class="send" name="button" @click="redirectCalculatorPage()">
        <img src="/wp-content/themes/lebe-childtheme/assets/images/ico/calculator.png" alt="">
        <span style="position: relative; display: inline-block; top: 10px;">
          Ajánlatkérés
        </span>
      </button>
    </div>
    <!-- HideShow button -->
    <div :class="'show-button ' + buttonDisplay" v-if="formStyle == 'vertical' && !checkDataIsEmpty && !isMobileView">
      <button type="button" name="button" @click="toggleVertical()">
        <span :class="'glyphicon glyphicon-menu-' + (hideStyle == 'hiding' ? 'left' : 'right')" style="position: relative; display: inline-block;"></span>
        <span style="font-weight: bold; position: relative; display: inline-block; top: -1px; padding-left: 4px;">Ajánlatkérés</span>
      </button>
    </div>
    <LanguagePopup
      v-if="languagePopup"
      :options="sourceLanguages"
      :show.sync="languagePopup"
      :lang.sync="sourceLanguage"
    />
    <LanguagesPopup
      v-if="languagesPopup"
      :options="targetLanguages"
      :show.sync="languagesPopup"
      :lang.sync="targetLanguage"
    />
  </div>
</template>
<script>
import ServiceType from './components/MiniField/ServiceType'
import SourceLanguage from './components/MiniField/SourceLanguage'
import TargetLanguage from './components/MiniField/TargetLanguage'
import Mail from './components/MiniField/Mail'
import Phone from './components/MiniField/Phone'
import LanguagePopup from './components/Popup/LanguagePopup'
import LanguagesPopup from './components/Popup/LanguagesPopup'

import Vue from 'vue'
//forrásnyelv kiválasztására szolgáló popup
Vue.component('LanguagePopup', LanguagePopup)
//célnyelvre szolgáló választó
Vue.component('LanguagesPopup', LanguagesPopup)

export default {
  name: 'miniform',
  data: function() {
    return {
      messageShown: false,
      formDatas: {},
      serviceType: 'translate',
      sourceLanguage: '',
      targetLanguage: [],
      mail: '',
      phone: '',
      fillingLevel: 0,
      languagePopup: false,
      //célnyelvekhez
      languagesPopup: false,
      //elem
      mainElement: {},
      //window vertical page offset
      verticalPageOffset: 0,
      pageWidth: 0,
      //api url
      apiUrl: '/wp-json/forditas_api/',
      hiding: true,
      productId: 0,
      buttonDisplay: 'hiding'
    }
  },
  components: {
    ServiceType,
    SourceLanguage,
    TargetLanguage,
    Mail,
    Phone,
    LanguagePopup
  },
  created() {
    //apply local storages data
    let storagedDataJson = localStorage.getItem("miniform-data")
    if(storagedDataJson != null) {
      let storagedData = JSON.parse(storagedDataJson)
      this.serviceType = storagedData['serviceType']
      this.sourceLanguage = storagedData['srcLanguage']
      this.targetLanguage = storagedData['tgtLanguage']
      this.mail = storagedData['email']
      this.phone = storagedData['phone']
    }
    //set product id
    this.productId = document.getElementById("miniform-product-data").dataset.id
  },
  mounted() {
    //környezet ellenőrzése
    if(process.env.NODE_ENV == 'development') {
      //dev modehoz a local development url hozzáadása
      this.apiUrl = "http://nonstopforditas-frontend.127.0.0.1.nip.io" + this.apiUrl
    }
    //formhoz tartozó adatok lekérése
    this.getFormDatas()
    this.updateResizeDependencies()

    //scroll funkciók létrehozása:
    window.addEventListener('resize', () => {
      this.updateResizeDependencies()
    })
    window.addEventListener('scroll', () => {
      this.updatePageOffset()
    })
    window.addEventListener('scroll', () => {
      // if( (window.innerWidth - event.clientX) < 300) {
      if (window.scrollY > 300) {
        this.buttonDisplay = 'showing'
      } else {
        this.buttonDisplay = 'hiding'
      }
    })
  },
  computed: {
    checkDataIsEmpty() {
      return Object.keys(this.formDatas).length === 0 && this.formDatas.constructor === Object
    },
    startTopPosition() {
      return this.mainElement.offsetTop
    },
    //megjelenítési stílus meghatározása
    formStyle() {
      //mobil nézetnél és legörgetésnél verikális nézetre váltás
      return this.pageWidth > 1200 && this.verticalPageOffset < this.startTopPosition  ? 'horizontal' : 'vertical'
    },
    //mobil view or not
    isMobileView() {
      return this.pageWidth <= 720
    },
    //fade in/out osztály meghatározása
    hideStyle() {
      if(this.hiding === true) {
        return 'hiding'
      } else if(this.hiding === false) {
        return 'showing'
      }
      return ''
    },
    targetLanguages() {
      let langs = []
      for(let key in this.formDatas['source_language']['datalist']['options']) {
        if(key != this.sourceLanguage) {
          langs.push({
            value: key,
            label: this.formDatas['source_language']['datalist']['options'][key].label
          })
        }
      }
      return langs
    },
    sourceLanguages() {
      let langs = {}
      for(let key in this.formDatas['source_language']['datalist']['options']) {
        if( typeof this.targetLanguage[0] == 'undefined' || key != this.targetLanguage[0].value) {
          langs[key] = this.formDatas['source_language']['datalist']['options'][key]
        }
      }
      return langs
    }
  },
  methods: {
    async getFormDatas() {
      const formDatas = await this.$http.get(this.apiUrl+'getData')
      this.formDatas = formDatas.data
    },
    // esemény követése
    track() {
        this.$gtag.event('CsaliGomb', {
          'event_category': 'BUTTON'
        })
    },

    updateResizeDependencies() {
      this.mainElement = document.getElementById('miniform')
      this.pageWidth = window.innerWidth
    },
    updatePageOffset() {
      this.verticalPageOffset = window.pageYOffset
    },
    toggleVertical() {
      this.hiding = !this.hiding
    },
    saveData() {
      if(this.fillingLevel == 5) {
        let miniformJson = JSON.stringify({
          serviceType: this.serviceType,
          srcLanguage: this.sourceLanguage,
          tgtLanguage: this.targetLanguage,
          email: this.mail,
          phone: this.phone
        });
        localStorage.setItem("miniform-data", miniformJson);
        //redirect
        window.location.href = "/?p=" + this.productId + '#forditas-urlap-adatok'
      } else {
        if(!this.messageShown) {
          this.messageShown = true;
          setTimeout(() => this.messageShown = false, 5000);
        }
      }
    },
    redirectCalculatorPage() {
      window.location.href = "/?p=" + this.productId
    }
  },
  destroyed() {
    window.removeEventListener('resize',this.updateResizeDependencies());
    window.removeEventListener('scroll',this.updatePageOffset());
  },
  watch: {
    pageWidth: function() {
      if(this.isMobileView) {
        this.hiding = false;
      }
    },
    sourceLanguage: function(val) {
      let filteredTgtLangs = [];
      //filter targetlangs
      this.targetLanguage.forEach((item) =>{
        if(item.value != val) {
          filteredTgtLangs.push(item);
        }
      });
      this.targetLanguage = filteredTgtLangs;
    }
  }
}
</script>
<style media="screen" lang="scss">
/* animations */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
//trick for css
@keyframes fadeIn2 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes hideVertical {
  0% {
    right: 0;
  }
  100% {
    right: -215px;
  }
}
//toggle vertical button
@keyframes hoverVerticalButton {
  0% {
    border-radius: 23px 0px 0px 23px;
  }
  100% {
    border-radius: 23px 15px 15px 23px;
  }
}
$miniform_line_width: 4px;
$miniform_item_circle_size: 46px;
$color-gray: gray;
$miniform_top_space: 0px;
$highlight-color: rgb(247, 173, 63);
$default-color: white;
$input-radius: 7px;
.horizontal .light-layer{
  animation-name: fadeIn2;
  animation-duration: .5s;
}
#miniform{
  position: static;
  padding: 0 20px;
  margin-bottom: 170px;
  .no-border{
    border-color: transparent !important;
  }
  .warning-message{
    bottom: 70px;
    position: absolute;
    background: #fff;
    border-radius: 7px;
    left: -100px;
    padding: 5px 20px;
  }
  .mobile-view{
    button.send{
      opacity: .85;
      border-radius: 5px 0 0 5px;
      padding: 0 10px 0 5px;
      height: auto;
      img{
        margin: 0;
        height: 36px;
      }
      span{
        display: block;
        float: right;
        line-height: normal;
        padding-top: 4px;
        padding-left: 3px;
        text-align: left;
      }
      &:hover{
        opacity: 1;
        transition: all .7s;
        box-shadow: 3px 3px 7px rgba(0,0,0,.4);
      }
    }
  }
  button.send{
    height: $miniform_item_circle_size;
    line-height: $miniform_item_circle_size;
    border-radius: $input-radius;
    background-color: $highlight-color;
    text-transform: none;
    padding-left: 20px;
    padding-right: 20px;
  }
  .light-layer {
    margin-top: -170px;
    position: relative;
    z-index: 1;
    margin-right: auto;
    margin-left: auto;
    max-width: 1540px;
    padding: 0;
    padding-left: 9%;
    background: rgba($default-color, 0.3);
    &>.row{
      select{
        //remove select arrow
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        line-height: 35px;
      }
      select,input{
        padding-right: 10px;
        padding-left: 10px;
      }
      &>.col{
        padding-left: 0;
        padding-right: 0;
        padding-top: $miniform_top_space;
        .form-item input{
          width: 150px;
          padding-left: 15px;
          padding-right: 15px;
        }
      }
      //utolsó elem (nem számozott)
      &>.col:not(.numbered){
        text-align: right;
        padding-top: $miniform_top_space + $miniform_item_circle_size * 4 / 5  + $miniform_line_width;
        .form-item{
          position: relative;
          left: -45%;
        }
      }
      &>.col.numbered{
        counter-increment: col;
        padding-bottom: 15px;
        border-color: $highlight-color;
        border-width: $miniform_line_width;
        border-top-style: solid;
        .form-item{
            text-align: center;
            position: relative;
            top: - $miniform_item_circle_size / 5;
            width: auto;
            max-width: 95%;
            margin: 0 auto;
            &>*{
              overflow: hidden;
              max-width: 100%;
              background: white;
              border-radius: $input-radius;
              display: inline-block;
              height: $miniform_item_circle_size;
            }
        }
        //disable last child border
        &:last-child{
          border-color: transparent !important;
        }
        &>.form-item{
          text-align: center;
          position: relative;
          left: -50%;
          margin-left: $miniform_item_circle_size;
        }
      }
      &>.col.numbered::before{
        content: counter(col);
        position: relative;
        top: -$miniform_top_space - ($miniform_item_circle_size + $miniform_line_width ) /2;
        line-height: $miniform_item_circle_size;
        height: $miniform_item_circle_size;
        width: $miniform_item_circle_size;
        background-color: $highlight-color;
        color: $default-color;
        text-align: center;
        display: inline-block;
        border-radius: 100%;
        font-size: 23px;
        font-weight: bold;
      }
    }
  }
  //normál vonal pszeudó osztályok
  $normal-color-line-classes: '.light-layer.level-0 > .row > .col.numbered,.light-layer.level-1 > .row > .col.numbered';
  //normál kör pszeudó osztályok
  $normal-color-circle-classes: '.light-layer.level-0 > .row > .col.numbered::before';
  //kitöltötségi szintek pszeudó osztályainak összegyűjtése
  @for $i from 1 through 5 {
    @if $i > 1 {
      $j: $i - 1;
      $normal-color-line-classes: "#{$normal-color-line-classes},.light-layer.level-#{$i} > .row > .col.numbered:nth-child( #{$j} ) ~ .col.numbered ";
    }
    $normal-color-circle-classes: "#{$normal-color-circle-classes},.light-layer.level-#{$i} > .row .col.numbered:nth-child( #{$i} ) ~ .col.numbered::before";
  }
  //kör (sorszámok)
  #{$normal-color-circle-classes} {
    background-color: $default-color;
    color: $color-gray;
  }
  //összekötő vonalak vonal
  #{$normal-color-line-classes} {
    border-color: $default-color;
    color: $color-gray;
  }
}
@mixin miniform-vertical{
  position: fixed;
  right: 0;
  top: 120px;
  padding-right: 0px;
  z-index: 99999999;
  width: 270px;
  $fadeTime: 1s;
  &.showing, &.hiding{
    transition: right $fadeTime;
    //elrejtés / megjelenítés gomb
    .show-button button{
      transition: all $fadeTime;
      border-radius: 23px;
    }
  }
  &.hiding{
    right: -215px;
    .light-layer{
      opacity: .8;
      transition: opacity .5s ease;
    }
    .show-button button{
      border-radius: 23px 0 0 23px;
      transition-property: border-radius;
      transition-property: left;
      transition-delay: .3s;
      transition-duration: 0.7s;
      width: 160px;
      left: -125px;
    }
    &:hover{
      .show-button button{
        border-radius: 23px 15px 15px 23px;
        transition-delay:  0s;
      }
      .light-layer{
        opacity: 1;
      }
    }
  }
  &.showing{
    right: 0px;
  }
  .show-button{
    position: absolute;
    transition: opacity .5s;
    &.hiding{
      opacity: 0;
    }
    button{
      position: relative;
      top: 10px;
      left: -25px;
      transition-delay: .3s;
      transition-duration: .7s;
      width: 160px;
      height: 40px;
      //height - border
      line-height: 40px;
      text-align: center;
      border-radius: 23px;
      padding: 0;
      color: #444;
      background: white;
      border: solid 2px rgba(#000, .7);
    }
  }
  .light-layer{
    margin: 0;
    padding-left: 0;
    padding-top: 1em;
    padding-bottom: 1em;
    background: rgba(#000, .6);
    border-radius: 10px 0 0 10px;
    border-right-style: none;
    box-shadow:  0px 0px 15px 0px rgba(0,0,0,.2);
    //bootstrap .row margin korrigálás
    padding-right: 15px;
    //use animate
    animation-name: fadeIn;
    animation-duration: 1s;
    .row{
      $number-border-size: 4px;
      //bootstrap .row margin korrigálás
      margin-left: -$miniform_item_circle_size / 2 - $number-border-size / 2;
      &>.col.col-md-2{
        width: 100% !important;
        border-top-style: none;
        display: flex;
        justify-content: right;
        &.numbered{
          align-items: center;
        }
        &.send{
          padding-top: 10px;
          padding-right: 23px;
          padding-left: 23px;
          text-align: right;
          padding-left: $miniform_item_circle_size + $number-border-size;
          button{
            width: 100%;
          }
        }
        //disable horizontal settings
        &.numbered::before,
        &>.form-item{
          position: static;
        }
        &.numbered::before {
          border: solid $number-border-size lighten($highlight-color, 20%);
          border-right-style: none;
          border-bottom-style: none;
          box-sizing: content-box;
        }
        &>.form-item{
          width: 180px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: $miniform_item_circle_size / 2;
          .form-box-item > *{
            border-style: none;
          }
          &>*{
            width: 100%;
            height: $miniform_item_circle_size * .95;
          }
        }
      }
    }
  }
}
//erre a media query extend fv alkalmazhatatlánsága miatt van szükség issue: https://github.com/sass/sass/issues/1050
.minform-vertical{
  @include miniform-vertical();
}
button.lang-select {
  width: 100%;
  line-height: normal;
  height: 35px;
  background: white;
  text-align: left;
  color: #555;
  text-transform: none;
  font-weight: normal;
  padding-right: 8px;
  &.locked{
    background: #eee;
  }
  span.glyphicon{
    float: right;
    opacity: .6;
    margin-top: 3px;
    color: #444;
  }
}
#miniform.vertical{
  @extend .minform-vertical;
}

</style>
